import { onRouteChange } from './history-observer';

export interface NavigationEntry {
  from: string;
  to: string;
  timestamp: number;
}

export function startNavigationCapture(
  callback: (entry: NavigationEntry) => void
): () => void {
  let currentUrl = window.location.href;

  function checkUrlChange(): void {
    const newUrl = window.location.href;
    if (newUrl !== currentUrl) {
      const entry: NavigationEntry = {
        from: currentUrl,
        to: newUrl,
        timestamp: Date.now(),
      };
      currentUrl = newUrl;
      try {
        callback(entry);
      } catch {
        // noop
      }
    }
  }

  return onRouteChange(checkUrlChange);
}
